export const countryOptions = [
  {key: 'afghanistan', en: 'Afghanistan', zh: '阿富汗'},
  {key: 'albania', en: 'Albania', zh: '阿爾巴尼亞'},
  {key: 'algeria', en: 'Algeria', zh: '阿爾及利亞'},
  {key: 'andorra', en: 'Andorra', zh: '安道爾'},
  {key: 'angola', en: 'Angola', zh: '安哥拉'},
  {
    key: 'antigua_and_barbuda',
    en: 'Antigua and Barbuda',
    zh: '安地卡及巴布達'
  },
  {key: 'argentina', en: 'Argentina', zh: '阿根廷'},
  {key: 'armenia', en: 'Armenia', zh: '亞美尼亞'},
  {key: 'australia', en: 'Australia', zh: '澳洲'},
  {key: 'austria', en: 'Austria', zh: '奧地利'},
  {key: 'azerbaijan', en: 'Azerbaijan', zh: '亞塞拜然'},
  {key: 'bahamas', en: 'Bahamas', zh: '巴哈馬'},
  {key: 'bahrain', en: 'Bahrain', zh: '巴林'},
  {key: 'bangladesh', en: 'Bangladesh', zh: '孟加拉'},
  {key: 'barbados', en: 'Barbados', zh: '巴貝多'},
  {key: 'belarus', en: 'Belarus', zh: '白俄羅斯'},
  {key: 'belgium', en: 'Belgium', zh: '比利時'},
  {key: 'belize', en: 'Belize', zh: '貝里斯'},
  {key: 'benin', en: 'Benin', zh: '貝寧'},
  {key: 'bhutan', en: 'Bhutan', zh: '不丹'},
  {key: 'bolivia', en: 'Bolivia', zh: '玻利維亞'},
  {
    key: 'bosnia_and_herzegovina',
    en: 'Bosnia and Herzegovina',
    zh: '波士尼亞與赫塞哥維納'
  },
  {key: 'botswana', en: 'Botswana', zh: '波札那'},
  {key: 'brazil', en: 'Brazil', zh: '巴西'},
  {key: 'brunei', en: 'Brunei', zh: '汶萊'},
  {key: 'bulgaria', en: 'Bulgaria', zh: '保加利亞'},
  {key: 'burkina_faso', en: 'Burkina Faso', zh: '布吉納法索'},
  {key: 'burundi', en: 'Burundi', zh: '蒲隆地'},
  {key: 'cabo_verde', en: 'Cabo Verde', zh: '維德角'},
  {key: 'cambodia', en: 'Cambodia', zh: '柬埔寨'},
  {key: 'cameroon', en: 'Cameroon', zh: '喀麥隆'},
  {key: 'canada', en: 'Canada', zh: '加拿大'},
  {
    key: 'central_african_republic',
    en: 'Central African Republic',
    zh: '中非共和國'
  },
  {key: 'chad', en: 'Chad', zh: '查德'},
  {key: 'chile', en: 'Chile', zh: '智利'},
  {key: 'china', en: 'China', zh: '中國'},
  {key: 'colombia', en: 'Colombia', zh: '哥倫比亞'},
  {key: 'comoros', en: 'Comoros', zh: '葛摩'},
  {
    key: 'congo_brazzaville',
    en: 'Congo (Congo-Brazzaville)',
    zh: '剛果共和國（布拉柴維爾）'
  },
  {key: 'costa_rica', en: 'Costa Rica', zh: '哥斯大黎加'},
  {key: 'cote_divoire', en: "Côte d'Ivoire", zh: '象牙海岸'},
  {key: 'croatia', en: 'Croatia', zh: '克羅埃西亞'},
  {key: 'cuba', en: 'Cuba', zh: '古巴'},
  {key: 'cyprus', en: 'Cyprus', zh: '賽普勒斯'},
  {key: 'czechia', en: 'Czechia (Czech Republic)', zh: '捷克共和國'},
  {
    key: 'democratic_republic_of_the_congo',
    en: 'Democratic Republic of the Congo',
    zh: '剛果民主共和國'
  },
  {key: 'denmark', en: 'Denmark', zh: '丹麥'},
  {key: 'djibouti', en: 'Djibouti', zh: '吉布地'},
  {key: 'dominica', en: 'Dominica', zh: '多米尼克'},
  {key: 'dominican_republic', en: 'Dominican Republic', zh: '多明尼加共和國'},
  {key: 'ecuador', en: 'Ecuador', zh: '厄瓜多'},
  {key: 'egypt', en: 'Egypt', zh: '埃及'},
  {key: 'el_salvador', en: 'El Salvador', zh: '薩爾瓦多'},
  {key: 'equatorial_guinea', en: 'Equatorial Guinea', zh: '赤道幾內亞'},
  {key: 'eritrea', en: 'Eritrea', zh: '厄利垂亞'},
  {key: 'estonia', en: 'Estonia', zh: '愛沙尼亞'},
  {key: 'eswatini', en: 'Eswatini (fmr. "Swaziland")', zh: '史瓦帝尼'},
  {key: 'ethiopia', en: 'Ethiopia', zh: '衣索比亞'},
  {key: 'fiji', en: 'Fiji', zh: '斐濟'},
  {key: 'finland', en: 'Finland', zh: '芬蘭'},
  {key: 'france', en: 'France', zh: '法國'},
  {key: 'gabon', en: 'Gabon', zh: '加彭'},
  {key: 'gambia', en: 'Gambia', zh: '甘比亞'},
  {key: 'georgia', en: 'Georgia', zh: '喬治亞'},
  {key: 'germany', en: 'Germany', zh: '德國'},
  {key: 'ghana', en: 'Ghana', zh: '迦納'},
  {key: 'greece', en: 'Greece', zh: '希臘'},
  {key: 'grenada', en: 'Grenada', zh: '格瑞那達'},
  {key: 'guatemala', en: 'Guatemala', zh: '瓜地馬拉'},
  {key: 'guinea', en: 'Guinea', zh: '幾內亞'},
  {key: 'guinea_bissau', en: 'Guinea-Bissau', zh: '幾內亞比索'},
  {key: 'guyana', en: 'Guyana', zh: '蓋亞那'},
  {key: 'haiti', en: 'Haiti', zh: '海地'},
  {key: 'holy_see', en: 'Holy See', zh: '教廷（梵蒂岡）'},
  {key: 'honduras', en: 'Honduras', zh: '宏都拉斯'},
  {key: 'hungary', en: 'Hungary', zh: '匈牙利'},
  {key: 'iceland', en: 'Iceland', zh: '冰島'},
  {key: 'india', en: 'India', zh: '印度'},
  {key: 'indonesia', en: 'Indonesia', zh: '印尼'},
  {key: 'iran', en: 'Iran', zh: '伊朗'},
  {key: 'iraq', en: 'Iraq', zh: '伊拉克'},
  {key: 'ireland', en: 'Ireland', zh: '愛爾蘭'},
  {key: 'israel', en: 'Israel', zh: '以色列'},
  {key: 'italy', en: 'Italy', zh: '義大利'},
  {key: 'jamaica', en: 'Jamaica', zh: '牙買加'},
  {key: 'japan', en: 'Japan', zh: '日本'},
  {key: 'jordan', en: 'Jordan', zh: '約旦'},
  {key: 'kazakhstan', en: 'Kazakhstan', zh: '哈薩克'},
  {key: 'kenya', en: 'Kenya', zh: '肯亞'},
  {key: 'kiribati', en: 'Kiribati', zh: '吉里巴斯'},
  {key: 'kuwait', en: 'Kuwait', zh: '科威特'},
  {key: 'kyrgyzstan', en: 'Kyrgyzstan', zh: '吉爾吉斯'},
  {key: 'laos', en: 'Laos', zh: '寮國'},
  {key: 'latvia', en: 'Latvia', zh: '拉脫維亞'},
  {key: 'lebanon', en: 'Lebanon', zh: '黎巴嫩'},
  {key: 'lesotho', en: 'Lesotho', zh: '賴索托'},
  {key: 'liberia', en: 'Liberia', zh: '賴比瑞亞'},
  {key: 'libya', en: 'Libya', zh: '利比亞'},
  {key: 'liechtenstein', en: 'Liechtenstein', zh: '列支敦斯登'},
  {key: 'lithuania', en: 'Lithuania', zh: '立陶宛'},
  {key: 'luxembourg', en: 'Luxembourg', zh: '盧森堡'},
  {key: 'madagascar', en: 'Madagascar', zh: '馬達加斯加'},
  {key: 'malawi', en: 'Malawi', zh: '馬拉威'},
  {key: 'malaysia', en: 'Malaysia', zh: '馬來西亞'},
  {key: 'maldives', en: 'Maldives', zh: '馬爾地夫'},
  {key: 'mali', en: 'Mali', zh: '馬利'},
  {key: 'malta', en: 'Malta', zh: '馬爾他'},
  {key: 'marshall_islands', en: 'Marshall Islands', zh: '馬紹爾群島'},
  {key: 'mauritania', en: 'Mauritania', zh: '茅利塔尼亞'},
  {key: 'mauritius', en: 'Mauritius', zh: '模里西斯'},
  {key: 'mexico', en: 'Mexico', zh: '墨西哥'},
  {key: 'micronesia', en: 'Micronesia', zh: '密克羅尼西亞'},
  {key: 'moldova', en: 'Moldova', zh: '摩爾多瓦'},
  {key: 'monaco', en: 'Monaco', zh: '摩納哥'},
  {key: 'mongolia', en: 'Mongolia', zh: '蒙古'},
  {key: 'montenegro', en: 'Montenegro', zh: '蒙特內哥羅'},
  {key: 'morocco', en: 'Morocco', zh: '摩洛哥'},
  {key: 'mozambique', en: 'Mozambique', zh: '莫三比克'},
  {key: 'myanmar', en: 'Myanmar (formerly Burma)', zh: '緬甸'},
  {key: 'namibia', en: 'Namibia', zh: '納米比亞'},
  {key: 'nauru', en: 'Nauru', zh: '諾魯'},
  {key: 'nepal', en: 'Nepal', zh: '尼泊爾'},
  {key: 'netherlands', en: 'Netherlands', zh: '荷蘭'},
  {key: 'new_zealand', en: 'New Zealand', zh: '紐西蘭'},
  {key: 'nicaragua', en: 'Nicaragua', zh: '尼加拉瓜'},
  {key: 'niger', en: 'Niger', zh: '尼日'},
  {key: 'nigeria', en: 'Nigeria', zh: '奈及利亞'},
  {key: 'north_korea', en: 'North Korea', zh: '北韓'},
  {key: 'north_macedonia', en: 'North Macedonia', zh: '北馬其頓'},
  {key: 'norway', en: 'Norway', zh: '挪威'},
  {key: 'oman', en: 'Oman', zh: '阿曼'},
  {key: 'pakistan', en: 'Pakistan', zh: '巴基斯坦'},
  {key: 'palau', en: 'Palau', zh: '帛琉'},
  {key: 'palestine_state', en: 'Palestine State', zh: '巴勒斯坦國'},
  {key: 'panama', en: 'Panama', zh: '巴拿馬'},
  {key: 'papua_new_guinea', en: 'Papua New Guinea', zh: '巴布亞紐幾內亞'},
  {key: 'paraguay', en: 'Paraguay', zh: '巴拉圭'},
  {key: 'peru', en: 'Peru', zh: '秘魯'},
  {key: 'philippines', en: 'Philippines', zh: '菲律賓'},
  {key: 'poland', en: 'Poland', zh: '波蘭'},
  {key: 'portugal', en: 'Portugal', zh: '葡萄牙'},
  {key: 'qatar', en: 'Qatar', zh: '卡達'},
  {key: 'romania', en: 'Romania', zh: '羅馬尼亞'},
  {key: 'russia', en: 'Russia', zh: '俄羅斯'},
  {key: 'rwanda', en: 'Rwanda', zh: '盧安達'},
  {
    key: 'saint_kitts_and_nevis',
    en: 'Saint Kitts and Nevis',
    zh: '聖克里斯多福及尼維斯'
  },
  {key: 'saint_lucia', en: 'Saint Lucia', zh: '聖露西亞'},
  {
    key: 'saint_vincent_and_the_grenadines',
    en: 'Saint Vincent and the Grenadines',
    zh: '聖文森及格瑞那丁'
  },
  {key: 'samoa', en: 'Samoa', zh: '薩摩亞'},
  {key: 'san_marino', en: 'San Marino', zh: '聖馬利諾'},
  {
    key: 'sau_tome_and_principe',
    en: 'Sao Tome and Principe',
    zh: '聖多美普林西比'
  },
  {key: 'saudi_arabia', en: 'Saudi Arabia', zh: '沙烏地阿拉伯'},
  {key: 'senegal', en: 'Senegal', zh: '塞內加爾'},
  {key: 'serbia', en: 'Serbia', zh: '塞爾維亞'},
  {key: 'seychelles', en: 'Seychelles', zh: '塞席爾'},
  {key: 'sierra_leone', en: 'Sierra Leone', zh: '獅子山'},
  {key: 'singapore', en: 'Singapore', zh: '新加坡'},
  {key: 'slovakia', en: 'Slovakia', zh: '斯洛伐克'},
  {key: 'slovenia', en: 'Slovenia', zh: '斯洛維尼亞'},
  {key: 'solomon_islands', en: 'Solomon Islands', zh: '索羅門群島'},
  {key: 'somalia', en: 'Somalia', zh: '索馬利亞'},
  {key: 'south_africa', en: 'South Africa', zh: '南非'},
  {key: 'south_korea', en: 'South Korea', zh: '南韓'},
  {key: 'south_sudan', en: 'South Sudan', zh: '南蘇丹'},
  {key: 'spain', en: 'Spain', zh: '西班牙'},
  {key: 'sri_lanka', en: 'Sri Lanka', zh: '斯里蘭卡'},
  {key: 'sudan', en: 'Sudan', zh: '蘇丹'},
  {key: 'suriname', en: 'Suriname', zh: '蘇利南'},
  {key: 'sweden', en: 'Sweden', zh: '瑞典'},
  {key: 'switzerland', en: 'Switzerland', zh: '瑞士'},
  {key: 'syria', en: 'Syria', zh: '敘利亞'},
  {key: 'tajikistan', en: 'Tajikistan', zh: '塔吉克'},
  {key: 'tanzania', en: 'Tanzania', zh: '坦尚尼亞'},
  {key: 'thailand', en: 'Thailand', zh: '泰國'},
  {key: 'timor_leste', en: 'Timor-Leste', zh: '東帝汶'},
  {key: 'togo', en: 'Togo', zh: '多哥'},
  {key: 'tonga', en: 'Tonga', zh: '東加'},
  {
    key: 'trinidad_and_tobago',
    en: 'Trinidad and Tobago',
    zh: '千里達及托巴哥'
  },
  {key: 'tunisia', en: 'Tunisia', zh: '突尼西亞'},
  {key: 'turkey', en: 'Turkey', zh: '土耳其'},
  {key: 'turkmenistan', en: 'Turkmenistan', zh: '土庫曼'},
  {key: 'tuvalu', en: 'Tuvalu', zh: '吐瓦魯'},
  {key: 'uganda', en: 'Uganda', zh: '烏干達'},
  {key: 'ukraine', en: 'Ukraine', zh: '烏克蘭'},
  {
    key: 'united_arab_emirates',
    en: 'United Arab Emirates',
    zh: '阿拉伯聯合大公國'
  },
  {key: 'united_kingdom', en: 'United Kingdom', zh: '英國'},
  {
    key: 'united_states_of_america',
    en: 'United States of America',
    zh: '美國'
  },
  {key: 'uruguay', en: 'Uruguay', zh: '烏拉圭'},
  {key: 'uzbekistan', en: 'Uzbekistan', zh: '烏茲別克'},
  {key: 'vanuatu', en: 'Vanuatu', zh: '萬那杜'},
  {key: 'venezuela', en: 'Venezuela', zh: '委內瑞拉'},
  {key: 'vietnam', en: 'Vietnam', zh: '越南'},
  {key: 'yemen', en: 'Yemen', zh: '葉門'},
  {key: 'zambia', en: 'Zambia', zh: '尚比亞'},
  {key: 'zimbabwe', en: 'Zimbabwe', zh: '辛巴威'}
];
